import React from "react";
import { Box } from "@chakra-ui/react";
import { VeriAsyncRouteComponentType } from "@verivest/shared-components/src/defines/after-js-types";
import { ManagerWhiteLabelRouteParams } from "../../../routes/investorPortalPages.types";
import {
  ManagerWhiteLabelRoutesServerInitialProps,
  WhiteLabelPageExtraProps,
} from "./types";
import { ManagerProfile } from "@verivest/shared-components/src/components/manager-profile/ManagerProfile";
import {
  buildRouteUrl,
  investorPortalWhiteLabelRoutes,
  managerWhiteLabelSectionParams,
  managerWhiteLabelSubSections,
} from "@verivest/shared-components";
import { useHistory } from "react-router-dom";
import { ManagerKeyPeopleModal } from "@verivest/shared-components/src/components/manager-profile/modals/ManagerKeyPeopleModal";
import { ManagerPrincipalModal } from "@verivest/shared-components/src/components/manager-profile/modals/ManagerPrincipalModal";

export const OverviewPage: VeriAsyncRouteComponentType<
  ManagerWhiteLabelRoutesServerInitialProps & WhiteLabelPageExtraProps,
  ManagerWhiteLabelRouteParams
> = ({ match, manager }) => {
  const history = useHistory();

  const onCloseModal = () => {
    history.push(
      buildRouteUrl(investorPortalWhiteLabelRoutes.whiteLabel, {
        [managerWhiteLabelSectionParams.section]: section,
      }),
    );
  };

  const {
    [managerWhiteLabelSectionParams.section]: section,
    [managerWhiteLabelSectionParams.subSection]: subSection,
    [managerWhiteLabelSectionParams.subSectionId]: subSectionId,
  } = match.params;

  if (!manager) return <></>;
  return (
    <>
      <Box className={"pb-10 sm:py-10"}>
        <ManagerProfile manager={manager} />
      </Box>
      <ManagerPrincipalModal
        isOpen={
          subSection === managerWhiteLabelSubSections.principal &&
          !!subSectionId
        }
        onClose={onCloseModal}
        autoFocus={false}
        principalId={subSectionId || ""}
        preserveScrollBarGap={false}
        returnFocusOnClose={false}
      />
      <ManagerKeyPeopleModal
        employees={manager.managerEmployees || []}
        isOpen={subSection === managerWhiteLabelSubSections.keyPeople}
        onClose={onCloseModal}
      />
    </>
  );
};

OverviewPage.getInitialProps = async () => {
  const result: ManagerWhiteLabelRoutesServerInitialProps = {};
  return result;
};

OverviewPage.getChunkName = () =>
  "investor-portal-3-manager-white-label-overview-page";
